import { ContentSection, DataOverview, DescriptionList } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { useMatchMakerWizard } from "../../hooks/useMatchMakerWizard";
import { getVehicleConditionDisplayName, getVehicleFuelTypesDisplayName } from "../../data/vehicle";
import { BrandType } from "@bus/models";
import { capitalizeBrand } from "../../helpers/capitalizeBrand";

export const VehicleCaracteristics = () => {
    const { t } = useTranslation(["summarypage"]);
    const { goToQuestionsStep, submitAnswersRequest } = useMatchMakerWizard();
    const { matchMakerAnswers } = submitAnswersRequest;
    const brand = process.env.REACT_APP_WEBSITE_BRAND;

    const getTitle = () => {
        switch (brand as BrandType) {
            case BrandType.VWN:
                return t("summarypage:vehicle-characteristics.titleVWN");
            case BrandType.VW:
                return t("summarypage:vehicle-characteristics.titleVW");
            default:
                return t("summarypage:vehicle-characteristics.title", {
                    brand: capitalizeBrand(brand as BrandType),
                });
        }
    }

    return (
        <ContentSection.ComponentWrapper>
            <DataOverview
                href=""
                titleLevel={2}
                title={getTitle()}
                buttonLabel={t("summarypage:edit")}
                buttonProps={{
                    id: "VehicleCharacteristicsSummaryEditButton",
                    onClick: (e) => {
                        e.preventDefault();
                        goToQuestionsStep(1, true);
                    },
                    tabIndex: 0,
                }}
                lang="it"
                id="VehicleCharacteristicsSummary"
            >
                {matchMakerAnswers && (
                    <DescriptionList grid>
                        <DescriptionList.Group termText={t("summarypage:vehicle-characteristics.condition")}>
                            <DescriptionList.Detail id="VehicleCaracteristicsCondition">
                                {matchMakerAnswers.conditions?.map((x, index) => {
                                    if (index + 1 < (matchMakerAnswers.conditions?.length ?? 0))
                                        return getVehicleConditionDisplayName(x, t) + ", ";
                                    return getVehicleConditionDisplayName(x, t);
                                })}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group termText={t("summarypage:vehicle-characteristics.model")}>
                            <DescriptionList.Detail id="VehicleCaracteristicsModel">
                                {matchMakerAnswers.models?.map((x, index) => {
                                    if (index + 1 < (matchMakerAnswers.models?.length ?? 0)) return x + ", ";
                                    return x;
                                })}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                        <DescriptionList.Group termText={t("summarypage:vehicle-characteristics.fuel")}>
                            <DescriptionList.Detail id="VehicleCaracteristicsFuel">
                                {matchMakerAnswers.fuelTypes?.map((x, index) => {
                                    if (index + 1 < (matchMakerAnswers.fuelTypes?.length ?? 0))
                                        return getVehicleFuelTypesDisplayName(x, t) + ", ";
                                    return getVehicleFuelTypesDisplayName(x, t);
                                })}
                            </DescriptionList.Detail>
                        </DescriptionList.Group>
                    </DescriptionList>
                )}
            </DataOverview>
        </ContentSection.ComponentWrapper>
    );
};
